import React from 'react';
import '../../../../css/common/chat/ChatComposer.css';

const resolveReplySnippetText = (reply) => {
  const type = String(reply?.type || '').trim().toLowerCase();
  if (type === 'file') {
    return String(reply?.fileName || 'ファイル').trim();
  }
  if (type === 'image') {
    return '画像';
  }
  return String(reply?.previewText || '').trim();
};

export default function ChatReplySnippet({ reply, onClick }) {
  if (!reply?.messageId) return null;
  const body = resolveReplySnippetText(reply);
  return (
    <button
      type="button"
      className={`chat-reply-snippet${reply?.isUnavailable ? ' is-unavailable' : ''}`}
      onClick={onClick}
      disabled={reply?.isUnavailable}
      title={reply?.isUnavailable ? '返信元メッセージは見つかりません' : '返信元メッセージへ移動'}
    >
      <span className="chat-reply-snippet__label">
        <i className="fa-solid fa-reply" aria-hidden="true" />
        <span>{String(reply?.senderName || '返信元').trim()}</span>
      </span>
      <span className="chat-reply-snippet__text">
        {reply?.isUnavailable ? '元メッセージは削除または非表示です。' : body}
      </span>
    </button>
  );
}
